import { FETCH_FILTER_FIELDS, FETCH_FILTER_FIELDS_FOR_SM } from 'src/constants';
import { IFilters2 } from 'src/components/filters';
import { axios } from 'src/lib';

/* Fetching filter data for given sourceID,scenarioID & moduleID  */
export function getFilterFields2(
  sourceId: number,
  moduleId: number = null,
  scenarioId: number = null
) {
  return axios
    .get(
      `${FETCH_FILTER_FIELDS}${sourceId || 1}/${
        moduleId !== null ? `${moduleId}/` : ''
      }${scenarioId !== null ? `${scenarioId}/` : ''}`
    )
    .then<IFilters2>((response) => {
      // filtering the filters on the basis of is_visible key
      const filters = response.data.filters.filter((e) => e.is_visible);
      // eslint-disable-next-line no-param-reassign
      response.data.filters = filters;
      return response.data;
    });
  // return SCENARIO_FILTER_DATA;
}

/* Fetching filter data for given sourceID,scenarioID & moduleID  */
export function getFilterFieldsForScenarioManager(sourceId: number) {
  return axios
    .get(`${FETCH_FILTER_FIELDS_FOR_SM}${sourceId}/`)
    .then<IFilters2>((response) => response.data);
  // return SCENARIO_FILTER_DATA;
}
